import { isValidElement, Key } from "react";
import { message, MessageArgsProps } from "antd";

export default () => {
  const [messageApi, contextHolder] = message.useMessage();

  const success = (p: React.ReactNode | MessageArgsProps) => {
    const param: MessageArgsProps =
      isValidElement(p) || typeof p === "string"
        ? { content: p }
        : (p as MessageArgsProps);
    setTimeout(() => {
      messageApi.open({
        type: "success",
        ...param,
        className: "sj-success-message " + param.className ?? "",
      });
    });
  };

  const error = (p: React.ReactNode | MessageArgsProps) => {
    const param: MessageArgsProps =
      isValidElement(p) || typeof p === "string"
        ? { content: p }
        : (p as MessageArgsProps);
    setTimeout(() => {
      messageApi.open({
        type: "error",
        ...param,
        className: "sj-error-message " + param.className ?? "",
      });
    });
  };

  const info = (p: React.ReactNode | MessageArgsProps) => {
    const param: MessageArgsProps =
      isValidElement(p) || typeof p === "string"
        ? { content: p }
        : (p as MessageArgsProps);
    setTimeout(() => {
      messageApi.open({
        type: "info",
        ...param,
        className: "sj-info-message " + param.className ?? "",
      });
    });
  };

  const warning = (p: React.ReactNode | MessageArgsProps) => {
    const param: MessageArgsProps =
      isValidElement(p) || typeof p === "string"
        ? { content: p }
        : (p as MessageArgsProps);
    setTimeout(() => {
      messageApi.open({
        type: "warning",
        ...param,
        className: "sj-warning-message " + param.className ?? "",
      });
    });
  };

  const loading = (p: React.ReactNode | MessageArgsProps) => {
    messageApi.loading(p);
  };

  const destroy = (key?: Key) => {
    messageApi.destroy(key);
  };

  return { success, error, warning, info, loading, destroy, contextHolder };
};
